// extracted by mini-css-extract-plugin
export default {"btn":"BtnPrimary_btn__JTkq1","rowIcon":"BtnPrimary_rowIcon__Givvt"};